import { IsEnum } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { MoveRecordInterface } from '../interfaces/move-record-interface';
import { MoveRecordDirection } from '../enum/ordering.enum';

@Exclude()
export class MoveRecordDto implements MoveRecordInterface {
  @Expose()
  @ApiProperty({
    title: 'Direction',
    description: 'Direction Enum to move record up or down.',
    enum: MoveRecordDirection,
  })
  @IsEnum(MoveRecordDirection)
  direction!: MoveRecordDirection;
}
